import React from 'react';
import { useFormikContext } from 'formik';
import { translations, personType, legalPersonType } from '../../lib/consts';
import { Typography } from '@mui/material';
import LegalIndividualSelector from '../LegalIndividualSelector';
import Individual, { IndividualCleanup } from '../Individual/Individual';
import LegalEntity, { LegalEntityCleanup } from '../LegalEntity/LegalEntity';

const OwnerSelector = () => {
    const { values, setFieldValue } = useFormikContext<any>();

    const handleChangeLegalPersonType = () => {
        LegalEntityCleanup(personType.owner, setFieldValue);
        IndividualCleanup(personType.owner, setFieldValue);
    };

    return (
        <>
            {(values.submitterIndividualPersonRole !== 1 || values.submitterLegalEntityPersonRole !== 1) && (
                <>
                    <Typography style={{ fontWeight: 'bold', fontSize: '18px' }} variant="caption">
                        {translations.CHOOSE_OWNER_TYPE + ' *'}
                    </Typography>

                    <LegalIndividualSelector
                        idIndividual="ownerIndividual"
                        idLegal="ownerLegal"
                        selectorType={personType.owner}
                        onChange={handleChangeLegalPersonType}
                    ></LegalIndividualSelector>
                    {values.ownerType === legalPersonType.individual && (
                        <Individual individualType={personType.owner} />
                    )}
                    {values.ownerType === legalPersonType.legal && <LegalEntity legalEntityType={personType.owner} />}
                </>
            )}
        </>
    );
};

export default OwnerSelector;
